import React from 'react'
import { withTranslation } from 'react-i18next'

import './PriceSwitcher.scss'

const PriceSwitcher = ({ defaultChecked, className = '', onSwitch, t }) => {
    const priceSwitcher = ev => onSwitch(ev.target.dataset.type)

    return (
        <div className={`price-switcher ${className}`}>
            <input type="radio" id="monthly" name="price-switcher" defaultChecked={defaultChecked === 'month'} />
            <label className="price-switcher__monthly" htmlFor="monthly" onClick={priceSwitcher} data-type="month">
                {t('_components._price_table._price_switcher.pay_monthly')}
            </label>
            <input type="radio" id="annualy" name="price-switcher" defaultChecked={defaultChecked === 'annual'} />
            <label className="price-switcher__annualy" htmlFor="annualy" onClick={priceSwitcher} data-type="annual">
                {t('_components._price_table._price_switcher.pay_annualy')}, <br />
                {t('_components._price_table._price_switcher.save_up_to_20')}
            </label>
        </div>
    )
}

export default withTranslation('translations')(PriceSwitcher)
